<template lang="pug">
.file-card
  .f-card-container
    vm-tooltip.fix-button(:text="$t('strings.options')" delay=".5s")
      vm-dropdown(vm-custom-content vm-trigger-click)
        vm-button(type="border" icon="more-vertical" color="#afbbc6")
        vm-dropdown-menu
          vm-dropdown-item.d-flex.justify-content-between(@click="downloadFile(model)")
            vm-icon(icon="download-outline")
            slot &nbsp;{{ $t('strings.download') }}
    .body-card(v-if="!!thumbnail" :style="!!thumbnail && `background: url(${encodeURI(thumbnail)}) no-repeat center / cover`" @click="downloadFile(model)")
    .icon-card(v-else @click="downloadFile(model)")
      img.icon(src='@/assets/icons/pdf.svg')
    .title-card(@click="downloadFile(model)")
      .format-icon
        vm-icon(icon="file-text-outline" size="1.2rem" color="rgb(13,67,81)")
      .title {{ model.folio }}
    .subtitles(@click="downloadFile(model)")
      span {{ model.description ? model.description : '' }}
      br
      span {{ model.created_at | moment('DD-MMMM-YYYY') }}
</template>

<script>
import axios from 'axios'
export default {
  name: 'FileDownloadCard',
  model: () => ({
    counter: 0
  }),
  props: {
    model: {
      type: Object,
      default: () => {}
    },
    modelText: {
      type: String,
      default: () => {}
    }
  },
  computed: {
  },
  methods: {
    downloadFile (model) {
      if (this.modelText !== 'packing_list') {
        window.open(`${axios.defaults.baseURL}/${this.modelText}/${model.id}/export?attention=&lang=es`, '_blank')
      } else {

      }
    }
  }
}
</script>
<style lang="scss" scoped>
.file-card {
  box-sizing: content-box;
  border: 3px solid transparent;
  transition: 0.05s all ease-in-out;
  border-radius: 10px;
  cursor: pointer;
  padding: 5px;
  width: 300px;
  margin: 10px;
  .f-card-container {
    min-width: 130px;
    height: 250px;
    border-radius: 10px;
    background: white;
    border: 1px solid rgb(226, 226, 226);
    -webkit-box-shadow: 0px 3px 0px 0px rgba(0,0,0,0.09);
    -moz-box-shadow: 0px 3px 0px 0px rgba(0,0,0,0.09);
    box-shadow: 0px 3px 0px 0px rgba(0,0,0,0.09);
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    user-select: none;
    transition: 0.3s all ease-in-out;
    position: relative;
  }
  &:hover {
    border: 3px solid rgba(var(--primary), 1);
  }
}
.body-card {
  height: 100%;
  width: 100%;
  background: white;
}
.icon-card {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon {
  width: 80px;
  height: auto;
}
.title-card {
  height: 60px;
  width: 100%;
  border-top: 1px solid rgb(226, 226, 226);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title {
  width: 100%;
  font-size: 13px;
}
.format-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px 0 15px;
}
button {
  border: 0 !important;
  cursor: pointer;
}
.fix-button {
  position: absolute;
  right: 0;
  top: 0;
}
.subtitles {
  display: inline-block;
  font-size: 11px;
  align-items: left;
  padding: 0px 18px 10px 18px;
}
.comments {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 13px;
  justify-content: space-between;
  padding: 0px 18px 10px 18px;
}
</style>
